export default function SVGOwl({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <g id="Owl-2">
        <path
          d="M184.28,9858.84s-18.24,124.35,55,201.66,92.24,72.43,92.24,72.43,81.28,15.06,105.86,68.32c30.52,46.78,24.31,76.49,39.78,71.63,2.24-.27,4.62-2.65,6.34-6.61,6.87-16,13.35-57.62,13.35-57.62l3.83-16.52s9.78,6,24.05-82.07c9.39-68.72,7.27-198.89-16.91-270.78S410.53,9668.52,303.88,9694c-101.49,29.34-117.09,109.16-112.07,151.45l-7.53,13.35"
          fill="#ececec"
        />
        <path
          d="M189.44,9836c0,22.87,3.83,65,38.06,83.13,16,8.46,34.75,9,51.67,2.77,33.17-12,37.4-35.55,67-16,35.29,23.26,124.1,43.48,125.55-63.43-11.23-122.77-104-23.66-104-23.66L335.47,9864l-83.79-8.19L189.44,9836"
          fill="#e2e2e2"
        />
        <path
          d="M352.91,9804.78c19.3-42.68,73.22-35.54,107-35-3.17,6.22,2.9,31.72,2.9,31.72s17.05,29.34,3,75.46c-24.84,59.08-99.24,23.79-99.24,23.79s-11.63-21-43.62-16-32,51.94-95,15.06c-67.67-53.52-27-126.2-27-126.2l9.25-15.2,34.62,10.44s54.85,0,72.16,42.16c16.52,36.6,9.25,36.6,16.52,36.6s19.16-42.68,19.29-42.82"
          fill="#f7f7f7"
        />
        <path
          d="M429.17,9932.31s-60.53,34.76,16.25,147.62a186.07,186.07,0,0,1,26.17,58.41c17.71,69.78,21.67,86.43,21.67,86.43l7.27-32.51-56-213.82-28.68-30"
          fill="#e2e2e2"
        />
        <path
          d="M415.82,9948.44s-21.15,35,25.9,108.36c44.27,54.72,37.66,73.35,47.18,99,1.58,4.09,6.47,34.49,9.78,34.49,2.64-1.06,8.19-16.25,13.87-65.94,16.79-124.63,2.52-163.08-14-191.63s-73.22-11-82.73,15.73"
          fill="#f7f7f7"
        />
        <path
          d="M377.62,9786.28c-.66.53-24.44,19.83-11.36,49.69,13.21,30.27,69.78,33.7,79-15.86S377.62,9786.28,377.62,9786.28Z"
          fill="#e2e2e2"
          opacity="0.72"
        />
        <path
          d="M227.76,9788c-.66.53-21,22.28-3.74,49.9s65.85,31.77,75.1-17.79S227.76,9788,227.76,9788Z"
          fill="#e2e2e2"
          opacity="0.72"
        />
        <path
          d="M225.65,9796.06s-18.64,41.5,28,54.32,48.9-34.89,44.67-45.46-20.22-32.91-30.39-32.78-37.8,11.24-42.29,23.92"
          fill="#fff"
        />
        <path
          d="M440.79,9795.14s18.64,41.49-28,54.45c-42.29,9.77-48.9-35-44.67-45.47s20.22-32.9,30.4-32.77,37.79,11.1,42.28,23.79"
          fill="#fff"
        />
        <path
          d="M316.3,10094.6c1.06.66,2.25,1.32,3.31,2"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
        <path
          d="M239.26,10013.33c12.55,20.61,35.15,52.33,66.74,74.66"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
        <path
          d="M239.26,10065.53c-49.16-69.25-87.49-158.59-39.65-289.42,73.74-119.21,177.62-78.9,177.62-78.9s-107-9.38-157.93,65.68-28.41,203.92,0,251.62,55.51,91.72,153.57,118.42c91.45,25,96.07,137,96.07,137"
          fill="#fff"
          opacity="0.63"
        />
        <path
          d="M332.56,9848.13l-1.32-.66-5-5.95s-4.89-10-9.12-30.52-29.74-33.7-29.74-33.7,32.91,0,46.26,70.83"
          fill="#fff"
          opacity="0.47"
        />
        <path
          d="M469.08,9919.89s-49.69,7-43.88,56.83c7.93,68.06,45.59,74.67,59.87,120.26,11.63,37.14,14.67,85.11,14,93.83-5.81-2.11-14-52.86-19.69-70.7-1.45-17.45-16.25-34.76-16.25-34.76s-27.64-34.63-34.63-47.58c-4.47-8.29-13.32-35.26-13.32-35.26a72.19,72.19,0,0,1-4.65-25.47V9964.3l4.63-15.86,13.34-14.54c-.13.13,25-19.16,40.58-14"
          fill="#fff"
        />
        <path
          d="M192.34,9794.87c-.66,2.12,2.91,64.76,41,93.7a52.46,52.46,0,0,0,52.47,6.21c27.62-11.89,34-15.86,47.7-11.36,0,0-15.46,2.11-22.46,7.93-17.31,11.23-38.06,38.85-82.07,10.44-42.69-31.72-42.82-80.62-41.5-86.57C188.91,9807.3,192.34,9794.87,192.34,9794.87Z"
          fill="#fff"
        />
        <path
          d="M343.4,9885.27s31.71,23.78,48.89,26.43c20.36,6.34,47.58.66,58.55-11.1s18.37-34.1,18.37-34.1-22.34,44.54-62.91,39-48.9-23.79-62.9-20.22"
          fill="#fff"
        />
      </g>
      <g id="Layer_3" data-name="Layer 3">
        <path
          d="M180.19,9851.44c4.75,4.75,6.6,13.34,4.09,26.29-18.37,99,61.32,238.68,159.38,258.23,41.89,8.33,89.47,40.84,112.46,102.16,3,8.19,5.95,16.52,8.59,25.24,4,12.95,16.92,13.09,19.83.53,2.11-9.51,4.23-18.9,6.21-27.75,14.54-66.08,28.68-134.14,30.26-202.07.66-30.52-2.38-65.68-17.05-93.17-8.06-15.06-22.46-23.78-39.64-22.46-18.9,1.32-39.78,12.95-48.5,30.26-10.31,20.62-3.17,49,4.09,69.91,13,37.66,48.24,62.11,59.87,100,4.89,15.6,7.8,31.72,11.23,47.71.93,4.36,3.18,25.11,9.39,26.17,4.49.79,7.13-7.8,8.19-10.84,17.44-44.8,25.9-132,17.44-256.91C516,9778,386.74,9613.69,237.41,9728.27c-93.57,86.16-32.78,169.15,13.21,183.69,40.71,12.82,49.3-27.62,83-28.54,13.87-.4,22.46,11,33.17,17.7,12.29,7.67,28.81,12.43,43.08,13.22,19.56,1.06,38.59-6.74,49.29-23.52A82.68,82.68,0,0,0,471.72,9843c-.66-14.14-5.16-27.62-8.86-41-3.43-12.42-8.06-26.3.27-37.93,5.81-8.19,18.37-7.93,27.36-9a236.09,236.09,0,0,0,23.65-4.36,4,4,0,0,1,2.51,7.53c-22.73,10-53.52,14.41-94.49,10.84-33.17-2.91-64.89,29.08-51.54,62.25,5,12.55,17.84,19.82,31.06,20.48,11,.53,22.33-2.91,30.26-10.44,25.37-20.88,9.65-51.14.53-58-7.27-2.51,2.25,27-10.18,25.64-7.13-.79-14-10.44-21.14-4.62a11.17,11.17,0,0,0-3.31,4.89,9.16,9.16,0,0,0-.13,5.94c1.32,3,5.16,4.37,8.46,3.84,17.05-2.78,23.39-30,9.38-39.91-10.57-7.41-17.31-11.37-43.34,3.83-29.47,17.31-26.57,63.7-38.73,64.89-12-1.19-9.25-47.58-38.72-64.89-26-15.2-32.9-11.37-43.34-3.83-13.88,10-7.54,37.13,9.38,39.91,3.3.53,7.14-.8,8.46-3.84a8.39,8.39,0,0,0-.13-5.94,9,9,0,0,0-3.31-4.89c-7.13-5.95-14,3.83-21.14,4.62-12.43,1.32-3.84-25.24-11.1-22.73-9.26,6.87-24.06,34.36,1.32,55.24,8.06,7.54,19.29,11,30.26,10.44,13.22-.66,25.9-7.93,31.06-20.48,13.48-33.17-18.37-65.15-51.54-62.25A175.36,175.36,0,0,1,199.74,9754"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </g>
  );
}

export function MobileSVGOwl({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <g id="Owl-2-2" data-name="Owl-2">
        <path
          d="M342.17,6524.2s-8,54.78,24.24,88.85S407.05,6645,407.05,6645s35.81,6.64,46.64,30.1c13.45,20.61,10.71,33.71,17.53,31.56,1-.12,2-1.16,2.79-2.91,3-7.05,5.88-25.39,5.88-25.39l1.69-7.28s4.31,2.65,10.6-36.16c4.14-30.27,3.2-87.63-7.45-119.3s-42.87-75.24-89.86-64c-44.72,12.92-51.59,48.09-49.38,66.73l-3.32,5.88"
          fill="#ececec"
        />
        <path
          d="M344.45,6514.13c0,10.08,1.68,28.64,16.77,36.63A27.93,27.93,0,0,0,384,6552c14.62-5.29,16.48-15.66,29.52-7,15.55,10.25,54.68,19.16,55.32-28-4.95-54.09-45.82-10.42-45.82-10.42l-14.21,19.91-36.92-3.61-27.42-8.73"
          fill="#e2e2e2"
        />
        <path
          d="M416.47,6500.38c8.51-18.81,32.26-15.66,47.15-15.42-1.4,2.74,1.28,14,1.28,14s7.51,12.93,1.32,33.25c-11,26-43.73,10.48-43.73,10.48s-5.12-9.25-19.22-7.05-14.1,22.89-41.86,6.64c-29.81-23.58-11.89-55.61-11.89-55.61l4.07-6.7,15.26,4.61s24.17,0,31.79,18.57c7.28,16.13,4.08,16.13,7.28,16.13s8.44-18.81,8.5-18.87"
          fill="#f7f7f7"
        />
        <path
          d="M450.07,6556.57s-26.67,15.31,7.16,65a81.81,81.81,0,0,1,11.53,25.73c7.81,30.75,9.55,38.09,9.55,38.09l3.21-14.33-24.68-94.21-12.64-13.22"
          fill="#e2e2e2"
        />
        <path
          d="M444.19,6563.67s-9.32,15.42,11.41,47.75c19.51,24.11,16.6,32.32,20.79,43.62.7,1.8,2.85,15.19,4.31,15.19,1.16-.46,3.61-7.16,6.11-29,7.4-54.91,1.11-71.85-6.17-84.43s-32.26-4.85-36.45,6.93"
          fill="#f7f7f7"
        />
        <path
          d="M427.36,6492.23c-.29.23-10.77,8.73-5,21.89,5.82,13.34,30.74,14.85,34.8-7S427.36,6492.23,427.36,6492.23Z"
          fill="#e2e2e2"
          opacity="0.72"
          style={{ isolation: 'isolate' }}
        />
        <path
          d="M361.33,6493a17.92,17.92,0,0,0-1.65,22c7.61,12.17,29,14,33.09-7.84S361.33,6493,361.33,6493Z"
          fill="#e2e2e2"
          opacity="0.72"
          style={{ isolation: 'isolate' }}
        />
        <path
          d="M360.4,6496.53s-8.21,18.29,12.34,23.94,21.54-15.37,19.68-20-8.91-14.5-13.39-14.45-16.65,5-18.63,10.54"
          fill="#fff"
        />
        <path
          d="M455.19,6496.13s8.22,18.28-12.33,24c-18.64,4.3-21.55-15.42-19.69-20s8.91-14.5,13.4-14.44,16.65,4.89,18.63,10.48"
          fill="#fff"
        />
        <path
          d="M400.34,6628.07c.47.29,1,.58,1.46.88"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M366.4,6592.26c5.53,9.09,15.49,23.06,29.4,32.9"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M366.4,6615.26c-21.66-30.51-38.55-69.87-17.47-127.52,32.49-52.52,78.26-34.76,78.26-34.76s-47.15-4.13-69.59,28.94-12.51,89.85,0,110.86,24.46,40.42,67.67,52.18c40.29,11,42.33,60.36,42.33,60.36"
          fill="#fff"
          opacity="0.63"
          style={{ isolation: 'isolate' }}
        />
        <path
          d="M407.51,6519.48l-.58-.29-2.21-2.63s-2.15-4.4-4-13.44-13.1-14.85-13.1-14.85,14.5,0,20.38,31.21"
          fill="#fff"
          opacity="0.47"
          style={{ isolation: 'isolate' }}
        />
        <path
          d="M467.66,6551.09s-21.9,3.09-19.34,25c3.5,30,20.09,32.9,26.38,53,5.13,16.36,6.47,37.5,6.17,41.34-2.56-.93-6.17-23.29-8.67-31.15-.64-7.69-7.16-15.31-7.16-15.31s-12.18-15.26-15.26-21c-2-3.65-5.87-15.53-5.87-15.53a31.9,31.9,0,0,1-2.05-11.23v-5.61l2-7,5.88-6.4c-.06,0,11-8.45,17.88-6.17"
          fill="#fff"
        />
        <path
          d="M345.73,6496c-.3.93,1.28,28.53,18.06,41.28a23.11,23.11,0,0,0,23.12,2.74c12.17-5.24,15-7,21-5,0,0-6.82.93-9.9,3.49-7.63,4.95-16.77,17.12-36.16,4.6-18.81-14-18.87-35.52-18.29-38.14C344.21,6501.49,345.73,6496,345.73,6496Z"
          fill="#fff"
        />
        <path
          d="M412.28,6535.84s14,10.48,21.54,11.65c9,2.79,21,.29,25.8-4.9s8.1-15,8.1-15-9.85,19.62-27.72,17.18-21.55-10.48-27.72-8.9"
          fill="#fff"
        />
      </g>
      <g id="Layer_3" data-name="Layer 3">
        <path
          d="M340.37,6520.94c2.09,2.09,2.91,5.87,1.8,11.58-8.09,43.62,27,105.16,70.23,113.78,18.45,3.67,39.42,18,49.55,45,1.32,3.61,2.62,7.28,3.78,11.12,1.77,5.71,7.46,5.77,8.74.23.93-4.19,1.86-8.32,2.74-12.22,6.4-29.12,12.63-59.11,13.33-89,.29-13.44-1.05-28.94-7.51-41-3.55-6.63-9.9-10.48-17.47-9.89-8.33.58-17.53,5.7-21.37,13.33-4.54,9.08-1.4,21.59,1.8,30.8,5.73,16.59,21.26,27.37,26.38,44.06,2.16,6.88,3.44,14,4.95,21,.41,1.92,1.4,11.07,4.14,11.53,2,.35,3.14-3.43,3.61-4.77,7.68-19.74,11.41-58.16,7.68-113.2-4.42-64.65-61.37-137-127.17-86.56-41.22,38-14.44,74.52,5.82,80.93,17.94,5.65,21.73-12.17,36.57-12.57,6.11-.18,9.9,4.84,14.62,7.79a42.24,42.24,0,0,0,19,5.83c8.62.47,17-3,21.72-10.36a36.43,36.43,0,0,0,5.53-21.07c-.29-6.23-2.27-12.17-3.9-18.07-1.51-5.47-3.55-11.59.12-16.71,2.56-3.61,8.09-3.49,12-4a102.11,102.11,0,0,0,10.42-1.92,1.77,1.77,0,0,1,1.11,3.32c-10,4.41-23.58,6.35-41.64,4.78-14.61-1.29-28.59,12.81-22.7,27.42,2.2,5.53,7.86,8.74,13.68,9a18.16,18.16,0,0,0,13.33-4.6c11.18-9.2,4.26-22.53.24-25.56-3.21-1.1,1,11.9-4.49,11.3-3.14-.35-6.17-4.6-9.31-2a4.92,4.92,0,0,0-1.46,2.16,4.05,4.05,0,0,0-.06,2.62,3.49,3.49,0,0,0,3.73,1.69c7.51-1.23,10.31-13.22,4.13-17.59-4.65-3.26-7.62-5-19.09,1.69-13,7.63-11.71,28.07-17.07,28.59-5.29-.52-4.07-21-17.06-28.59-11.45-6.7-14.49-5-19.09-1.69-6.12,4.41-3.33,16.36,4.13,17.59a3.46,3.46,0,0,0,3.73-1.69,3.7,3.7,0,0,0-.06-2.62,4,4,0,0,0-1.46-2.16c-3.14-2.62-6.17,1.69-9.31,2-5.48.58-1.7-11.12-4.89-10-4.08,3-10.61,15.14.58,24.34a18.15,18.15,0,0,0,13.33,4.6c5.82-.29,11.41-3.49,13.69-9,5.93-14.61-8.1-28.71-22.71-27.43A76.88,76.88,0,0,1,349,6478"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  );
}
